/* eslint-disable */
import { gsap, TweenLite } from "gsap/all";

const elements = [
  { element: document.getElementById('lp1-base-image'), xCoef: 30, yCoef: 30, rotateCoef: 3 },
  { element: document.querySelector('.lp1-icon-1'), xCoef: 50, yCoef: 50, rotateCoef: 5 },
  { element: document.querySelector('.lp1-icon-2'), xCoef: 30, yCoef: 30, rotateCoef: 3 },
  { element: document.querySelector('.lp1-icon-3'), xCoef: 50, yCoef: 50, rotateCoef: 5 },
  { element: document.querySelector('.lp1-icon-4'), xCoef: 30, yCoef: 30, rotateCoef: 3 },
  { element: document.querySelector('.lp1-icon-5'), xCoef: 40, yCoef: 40, rotateCoef: 4 },
];

document.addEventListener('mousemove', (event) => {
  const xPos = (event.clientX / window.innerWidth) - 0.5;
  const yPos = (event.clientY / window.innerHeight) - 0.5;

  elements.forEach(({ element, xCoef, yCoef, rotateCoef }) => {
    if (element) {
      TweenLite.to(element, 1, {
        x: xPos * xCoef,
        y: yPos * yCoef,
        rotate: xPos * rotateCoef - 1,
        ease: 'power1.out',
      });
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/js/imagesmove.js